module.exports = __webpack_public_path__ + "static/bcs_coding_kids-06185a2786c230d9b508a0dde04bd8be.jpg";